import React from 'react';

import { Code, CodeOff } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';

import { HighlightableString } from '@/app/log-viewer/highlighting/HighlightableString';
import {
  HighlightableStringExpandableContainer,
  isExpandedState,
  toggleExpandingStateManually,
} from '@/app/log-viewer/highlighting/HighlightableStringExpandableContainer';
import { HighlightableStringView } from '@/app/log-viewer/highlighting/HighlightableStringView';

type Props = {
  modelData: DeepReadonly<RawContentModelData>;
  onDataChange: (change: DeepPartial<RawContentModelData>) => void;
};

export interface RawContentModelData extends HighlightableStringExpandableContainer {
  title: HighlightableString;
  linesCount: HighlightableString | null;
  lines: {
    number: HighlightableString;
    content: HighlightableString;
  }[];
}

export class RawContent extends React.Component<Props> {
  render() {
    const data = this.props.modelData;
    const isExpanded = isExpandedState(data.expandingState);

    return (
      <div>
        <Tooltip title="Toggle raw content">
          <Button
            size="small"
            variant="outlined"
            color="inherit"
            className="rawContentToggleButton"
            startIcon={isExpanded ? <CodeOff /> : <Code />}
            onClick={() => {
              this.props.onDataChange({
                expandingState: toggleExpandingStateManually(this.props.modelData.expandingState),
              });
            }}
          >
            RAW
          </Button>
        </Tooltip>
        {isExpanded ? (
          <div className="rawContentContainer">
            <div className="rawContentHeader">
              <HighlightableStringView string={data.title} />

              {data.linesCount ? (
                <>
                  &nbsp;
                  <HighlightableStringView string={data.linesCount} />
                </>
              ) : null}
            </div>
            <div className="verbatim-multiline">
              {data.lines.map((l, index) => {
                return (
                  <div key={index}>
                    <span style={{ color: 'gray' }}>
                      <HighlightableStringView string={l.number} />
                    </span>
                    &nbsp;
                    <HighlightableStringView string={l.content} />
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
